import { z } from "zod"

import { commandEnvelopeV1Schema } from "./command-envelope-v1.js"
import {
  fieldBeforeAfterRoleV1Schema,
  fieldBeforeAfterSourceV1Schema,
} from "./field-before-after-v1.js"
import {
  FIELD_MEDIA_MAXIMUM_BYTES,
  fieldMediaTypeV1Schema,
} from "./field-media-v1.js"
import { entityIdSchema } from "./identifiers.js"

export const fieldMediaUploadInitiateV2Schema = z
  .object({
    requestVersion: z.literal(2),
    mediaId: entityIdSchema,
    visitId: entityIdSchema,
    beforeAfterSetId: entityIdSchema,
    role: fieldBeforeAfterRoleV1Schema,
    source: fieldBeforeAfterSourceV1Schema,
    fileName: z
      .string()
      .min(1)
      .max(128)
      .regex(/^[A-Za-z0-9][A-Za-z0-9._ -]*$/),
    mediaType: fieldMediaTypeV1Schema.exclude(["application/pdf"]),
    sizeBytes: z.number().int().min(1).max(FIELD_MEDIA_MAXIMUM_BYTES).safe(),
    sha256: z.string().regex(/^[0-9a-f]{64}$/),
    capturedAt: z.iso.datetime({ offset: true }),
    associationCommand: commandEnvelopeV1Schema,
  })
  .strict()
  .superRefine((request, context) => {
    const command = request.associationCommand
    const payload = command.payload
    if (
      command.commandType !== "visit.media.associate" ||
      command.commandVersion !== 2 ||
      command.context.entityType !== "visit" ||
      command.context.entityId !== request.visitId ||
      command.expectedVersion === null ||
      payload.mediaId !== request.mediaId ||
      payload.visitId !== request.visitId ||
      payload.beforeAfterSetId !== request.beforeAfterSetId ||
      payload.role !== request.role ||
      payload.source !== request.source ||
      payload.fileName !== request.fileName ||
      payload.mediaType !== request.mediaType ||
      payload.sizeBytes !== request.sizeBytes ||
      payload.sha256 !== request.sha256 ||
      payload.capturedAt !== request.capturedAt ||
      payload.storageReference !== `field-media:${request.mediaId}`
    ) {
      context.addIssue({
        code: "custom",
        path: ["associationCommand"],
        message: "Before/After media association must match the upload.",
      })
    }
  })

export type FieldMediaUploadInitiateV2 = z.infer<
  typeof fieldMediaUploadInitiateV2Schema
>
